export default {
  checkInterval: '檢查間隔',
  newCommitCheckInterval: '檢查新提交的間隔',
  schedule: '排程',
  newSchedule: '新增排程',
  deleteSchedule: '刪除排程',
  editSchedule: '編輯排程',
  backup: '備份專案',
  downloadTheProjectBackupFile: '下載專案備份檔案。',
  restoreProject: '還原專案...',
  incorrectUsrPwd: '帳號或密碼不正確',
  askDeleteUser: '您確定要刪除這個使用者嗎？',
  askDeleteTemp: '您確定要刪除這個範本嗎？',
  askDeleteEnv: '您確定要刪除這個變數群組嗎？',
  askDeleteInv: '您確定要刪除這個清單嗎？',
  askDeleteKey: '您確定要刪除這個金鑰嗎？',
  askDeleteRepo: '您確定要刪除這個儲存庫嗎？',
  askDeleteProj: '您確定要刪除這個專案嗎？',
  askDeleteTMem: '您確定要刪除這個團隊成員嗎？',
  askDeleteSchedule: '您確定要刪除這個排程嗎？',
  edit: '編輯',
  nnew: '新增',
  keyFormSshKey: 'SSH 金鑰',
  keyFormLoginPassword: '使用密碼登入',
  keyFormNone: '無',
  incorrectUrl: '不正確的 URL',
  username: '使用者名稱',
  username_required: '使用者名稱是必填的',
  dashboard: '儀表板',
  history: '歷史',
  activity: '活動',
  settings: '設定',
  signIn: '登入',
  password: '密碼',
  changePassword: '更改密碼',
  editUser: '編輯使用者',
  newProject: '新增專案',
  close: '關閉',
  newProject2: '新增專案...',
  demoMode: '示範模式',
  task: '任務 #{expr}',
  youCanRunAnyTasks: '您可以執行任何任務',
  youHaveReadonlyAccess: '您擁有唯讀存取權限',
  taskTemplates: '任務範本',
  inventory: '清單',
  environment: '變數群組',
  keyStore: '金鑰儲存',
  repositories: '儲存庫',
  darkMode: '深色模式',
  team: '團隊',
  users: '使用者',
  editAccount: '編輯帳號',
  signOut: '登出',
  error: '錯誤',
  refreshPage: '重新整理頁面',
  relogin: '重新登入',
  howToFixSigninIssues: '如何修復登入問題',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: '首先，您需要存取 Semaphore 所在的伺服器。',
  executeTheFollowingCommandOnTheServerToSeeExisting: '在伺服器上執行以下命令以查看現有使用者：',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: '您可以更改現有使用者的密碼：',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: '或建立新的管理員使用者：',
  close2: '關閉',
  semaphore: 'Semaphore',
  dontHaveAccountOrCantSignIn: '沒有帳號或無法登入？',
  password2: '密碼',
  cancel: '取消',
  noViews: '沒有檢視',
  addView: '新增檢視',
  editEnvironment: '編輯變數群組',
  deleteEnvironment: '刪除變數群組',
  newEnvironment: '新增群組',
  environmentName: '群組名稱',
  dockerImage: '執行器 Docker 映像檔（選填）',
  extraVariables: '額外變數',
  enterExtraVariablesJson: '輸入額外變數 JSON...',
  environmentVariables: '環境變數',
  enterEnvJson: '輸入環境變數 JSON...',
  environmentAndExtraVariablesMustBeValidJsonExample: '環境變數和額外變數必須是有效的 JSON。範例：',
  dashboard2: '儀表板',
  ansibleSemaphore: 'Semaphore UI',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: '很抱歉，<%= htmlWebpackPlugin.options.title %> 需要啟用 JavaScript 才能正常運作。請啟用後再繼續。',
  deleteInventory: '刪除清單',
  newInventory: '新增清單',
  name: '名稱',
  userCredentials: '使用者憑證',
  sudoCredentialsOptional: 'Sudo 憑證（選填）',
  type: '類型',
  pathToInventoryFile: '清單檔案路徑',
  enterInventory: '輸入清單...',
  staticInventoryExample: '靜態清單範例：',
  staticYamlInventoryExample: '靜態 YAML 清單範例：',
  keyName: '金鑰名稱',
  loginOptional: '登入（選填）',
  usernameOptional: '使用者名稱（選填）',
  privateKey: '私鑰',
  override: '覆寫',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: '適用於 HTTPS 儲存庫及使用非 SSH 連線的 Playbook。',
  deleteKey: '刪除金鑰',
  newKey: '新增金鑰',
  create: '建立',
  newTask: '新增任務',
  cantDeleteThe: '無法刪除 {objectTitle}',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: '{objectTitle} 無法刪除，因為以下資源正在使用它',
  projectName: '專案名稱',
  allowAlertsForThisProject: '啟用此專案的警報',
  telegramChatIdOptional: 'Telegram 聊天 ID（選填）',
  maxNumberOfParallelTasksOptional: '最大平行任務數（選填）',
  deleteRepository: '刪除儲存庫',
  newRepository: '新增儲存庫',
  urlOrPath: 'URL 或路徑',
  absPath: '絕對路徑',
  branch: '分支',
  accessKey: '存取金鑰',
  credentialsToAccessToTheGitRepositoryItShouldBe: '用於存取 Git 儲存庫的憑證，應為：',
  ifYouUseGitOrSshUrl: '如果您使用 Git 或 SSH URL。',
  ifYouUseHttpsOrFileUrl: '如果您使用 HTTPS 或檔案 URL。',
  none: '無',
  ssh: 'SSH',
  deleteProject: '刪除專案',
  save: '儲存',
  deleteProject2: '刪除專案',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: '刪除專案後將無法復原，請審慎操作。',

  clear_cache: '清除快取',
  clear_cache_message: '刪除與此專案相關的所有快取檔案。此操作不可逆。',

  name2: '名稱 *',
  title: '標題 *',
  description: '描述',
  required: '必填',
  key: '{expr}',
  surveyVariables: '調查變數',
  addVariable: '新增變數',
  vaultName: '保險庫 ID（選填）',
  vaultNameDefault: '僅允許一個 `default`（空白）名稱',
  default_value: '預設值',
  vaultNameUnique: '必須是唯一的',
  vaultTypePassword: '密碼',
  vaultTypeScript: '客戶端腳本',
  vaultScript: '腳本路徑',
  vaultScriptRequired: '腳本路徑是必填的',
  vaultScriptClientRequired: '腳本路徑必須以 \' -client \' 和副檔名結尾',
  vaults: '保險庫',
  vaultAdd: '新增保險庫',
  vaultRequired: '保險庫密碼是必填的',
  columns: '欄位',
  buildVersion: '建置版本',
  messageOptional: '訊息（選填）',
  debug: '除錯',
  dryRun: '模擬執行',
  diff: '差異',
  advanced: '進階',
  hide: '隱藏',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: '請在任務範本設定中允許覆寫 CLI 參數',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'CLI 參數（JSON 陣列）。範例： [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: '已開始',
  author: '作者',
  duration: '持續時間',
  stop: '停止',
  forceStop: '強制停止',
  stopAll: '停止全部',
  stopAllTasks: '停止所有任務',
  askStopAllTasks: '您確定要停止所有任務嗎？',
  forceStopAllTasks: '強制停止所有任務',
  askForceStopAllTasks: '您確定要強制停止所有任務嗎？',
  raw_log: '原始日誌',

  confirmTask: '確認',
  deleteTeamMember: '刪除團隊成員',
  team2: '團隊',
  newTeamMember: '新增團隊成員',
  user: '使用者',
  administrator: '管理員',
  definesStartVersionOfYourArtifactEachRunIncrements: '定義產出物的起始版本。每次執行都會遞增產出物版本。',
  forMoreInformationAboutBuildingSeeThe: '有關建置的更多資訊，請參見',
  taskTemplateReference: '任務範本參考',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: '定義任務執行時要部署的產出物。',
  forMoreInformationAboutDeployingSeeThe: '有關部署的更多資訊，請參見',
  taskTemplateReference2: '任務範本參考',
  definesAutorunSchedule: '定義自動執行排程。',
  forMoreInformationAboutCronSeeThe: '有關 cron 的更多資訊，請參見',
  cronExpressionFormatReference: 'Cron 表示式格式參考',
  startVersion: '起始版本',
  example000: '範例： 0.0.0',
  buildTemplate: '建置範本',
  autorun: '自動執行',
  playbookFilename: 'Playbook 檔案路徑 *',
  exampleSiteyml: '範例： deploy/site.yml',
  inventory2: '清單 *',
  repository: '儲存庫',
  environment3: '變數群組 *',
  vaultPassword: '保險庫密碼',
  vaultPassword2: '保險庫密碼',
  view: '檢視',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: '偵測到新的 Git 提交時自動執行任務',
  repository2: '儲存庫',
  cronChecksNewCommitBeforeRun: 'Cron 會在執行前檢查新提交',
  readThe: '閱讀',
  toLearnMoreAboutCron: '以了解有關 Cron 的更多資訊。',
  suppressSuccessAlerts: '隱藏成功通知',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'CLI 參數（JSON 陣列）。範例： [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI 參數',
  docs: '文件',
  editViews: '編輯檢視',
  newTemplate: '新增範本',
  taskTemplates2: '任務範本',
  all: '所有',
  notLaunched: '未啟動',
  by: '由 {user_name}',
  editTemplate: '編輯範本',
  newTemplate2: '新增範本',
  deleteTemplate: '刪除範本',
  playbook: 'Playbook',
  email: '電子郵件',
  adminUser: '管理員使用者',
  sendAlerts: '發送警報',
  deleteUser: '刪除使用者',
  newUser: '新增使用者',
  re: '重新 {getActionButtonTitle}',
  teamMember: '{expr} 團隊成員',
  taskId: '任務 ID',
  version: '版本',
  status: '狀態',
  start: '開始',
  actions: '操作',
  alert: '警報',
  admin: '管理員',
  role: '角色',
  external: '外部',
  time: '時間',
  path: '路徑',
  gitUrl: 'Git URL',
  sshKey: 'SSH 金鑰',
  lastTask: '上次任務',
  task2: '任務',
  build: '建置',
  deploy: '部署',
  run: '執行',
  add: '新增',
  password_required: '密碼是必填的',
  name_required: '名稱是必填的',
  user_credentials_required: '使用者憑證是必填的',
  type_required: '類型是必填的',
  path_required: '清單檔案路徑是必填的',
  private_key_required: '私鑰是必填的',
  project_name_required: '專案名稱是必填的',
  repository_required: '儲存庫是必填的',
  branch_required: '分支是必填的',
  key_required: '金鑰是必填的',
  user_required: '使用者是必填的',
  build_version_required: '建置版本是必填的',
  title_required: '標題是必填的',
  isRequired: '是必填的',
  mustBeInteger: '必須是整數',
  mustBe0OrGreater: '必須大於或等於 0',
  start_version_required: '起始版本是必填的',
  playbook_filename_required: 'Playbook 檔案名稱是必填的',
  inventory_required: '清單是必填的',
  environment_required: '變數群組是必填的',
  email_required: '電子郵件是必填的',
  build_template_required: '建置範本是必填的',
  Task: '任務',
  Build: '建置',
  Deploy: '部署',
  Run: '執行',
  ReBuild: '重建',
  ReDeploy: '重新部署',
  ReRun: '重新執行',
  CreateDemoProject: '建立示範專案',
  LeaveProject: '離開專案',
  integration: '整合',
  integrations: '整合',
  NewIntegration: '新增整合',
  EditIntegration: '編輯整合',
  DeleteIntegration: '刪除整合',
  DeleteIntegrationMsg: '您確定要刪除這個整合嗎？',
  AddAlias: '新增別名',
  LoadAlias: '正在載入別名...',
  globalAlias: '使用專案別名',
  matcher: '比對器',
  matchType: '比對類型',
  newMatcher: '新增比對器',
  matchMethod: '比較方法',
  matchBodyDataType: '主體資料類型',
  extractValue: '擷取值',
  newExtractedValue: '新增擷取值',
  extractedValueSource: '值來源',
  matchKey: '鍵',
  matchValue: '值',
  matchOn: '比對於',
  runners: '執行器',
  newRunner: '新增執行器',
  enabled: '已啟用',
  scheduleNextRun: '下一次執行',
  maxNumberOfParallelTasks: '最大平行任務數',
  runnerUsage: '使用：',
  runnerDockerCommand: 'Docker：',
  runnerToken: 'Token：',
  editRunner: '編輯執行器',
  deleteRunner: '刪除執行器',
  newRunnerToken: '新增執行器',
  askDeleteRunner: '您確定要刪除執行器 {runner} 嗎？',
  roles_only_enterprise: '角色功能僅在 <b>Enterprise</b> 版本中可用。',
  project_runners_only_pro: '專案級執行器僅供 <b>PRO</b> 使用者使用。',
  secret_storage_only_pro: '密鑰儲存區僅供 <b>PRO</b> 使用者使用。',
  foss_runners_limited: '開源版本功能有限，完整功能請使用 <b>PRO</b> 版本。',
  learn_more_about_pro: '了解更多',
  upgrade_to_pro: '升級',
  contact_admin_to_upgrade: '請聯絡管理員以啟用 PRO 功能。',
  contact_admin_to_upgrade_enterprise: '請聯絡管理員以啟用 Enterprise 功能。',

  projectRestoreResult: '專案還原結果',
  projectWithNameRestored: '專案 {projectName} 已成功還原。',
  pleaseUpdateAccessKeys: '請在執行任務前先更新。',
  emptyKeysRestored: '已新增 {emptyKeys} 個空金鑰。',
  template: '範本',
  aliasUrlCopied: '別名 URL 已複製到剪貼簿。',
  yes: '是',
  activeTasks: '進行中的任務',
  taskLocation: '位置',
  empty: '空',
  noValues: '沒有值',
  addArg: '新增參數',

  status_success: '成功',
  status_failed: '失敗',
  status_stopped: '已停止',

  api_tokens: 'API Token',

  // Terraform/OpenTofu/Terragrunt
  auto_approve: '自動核准',
  auto_destroy: '允許銷毀',
  terraform_override_backend: '覆寫後端設定',
  terraform_backend_filename: '後端檔案名稱（預設：backend.tf）',
  terraform_invalid_backend_filename: '無效的後端檔案名稱',

  // Ansible
  tag: '標籤',
  tag_required: '標籤是必填的',
  allowInventoryInTask: '清單',
  allowLimitInTask: '限制',
  addLimit: '新增限制',
  allowDebug: '除錯',
  addTag: '新增標籤',
  skipTags: '跳過標籤',
  addSkippedTag: '新增跳過的標籤',
  tags: '標籤',
  limit: '限制',

  runner_tag: '執行器標籤',
  allow_parallel_tasks: '允許平行任務',
  task_prompts: '提示',
  template_advanced: '進階選項',
  template_app_options: '{app} 選項',
  template_app_prompts: '{app} 提示',
  general_settings: '一般',
  danger_zone_settings: '危險區域',
  project_stats: '統計',
  allow_override_branch: '分支',
  template_common_options: '通用選項',

  template_tasks: '任務',
  template_details: '詳細資訊',
  template_tf_workspaces: '工作區',

  // Role-related translations
  slug: 'Slug',
  slug_required: 'Slug 是必填的',
  slugHint: '唯一識別碼（僅限小寫英數字、底線及連字號）',
  invalidSlugFormat: 'Slug 僅允許小寫英數字、底線及連字號',
  permissions: '權限',
  canRunProjectTasks: '可執行專案任務',
  canUpdateProject: '可更新專案',
  canManageProjectResources: '可管理專案資源',
  canManageProjectUsers: '可管理專案使用者',
  newRole: '新增角色',
  editRole: '編輯角色',
  deleteRole: '刪除角色',
  askDeleteRole: '您確定要刪除這個角色嗎？',
  Roles: '角色',
  role_required: '角色是必填的',

  templatePermission: '範本權限',
};
